(function () {
  var configElement = document.getElementById('cg-starter-pack-view-item-config');
  if (!configElement || window.__cgStarterPackViewItemStarted) return;
  var config = JSON.parse(configElement.textContent);
  window.__cgStarterPackViewItemStarted = true;

  function hasProductView(layer) {
    return layer.some(function (entry) {
      var products = entry && entry.ecommerce && entry.ecommerce.detail && entry.ecommerce.detail.products;
      return entry && entry.event === 'dl_view_item' && Array.isArray(products) && products.some(function (product) {
        return String(product.variant_id) === config.product.variant_id;
      });
    });
  }

  function check() {
    var dataLayer = window.dataLayer || [];
    var elevarLayer = window.ElevarDataLayer;
    if (hasProductView(dataLayer) || (Array.isArray(elevarLayer) && hasProductView(elevarLayer))) return;

    // Wait for the base event forwarded by Elevar, not merely queued for processing.
    // Never bypass this prerequisite on a timer: consent can delay initialization.
    var userData = dataLayer.find(function (entry) {
      return entry && entry.event === 'dl_user_data';
    });
    if (!userData || !elevarLayer || typeof elevarLayer.push !== 'function') {
      setTimeout(check, 250);
      return;
    }

    var product = Object.assign({}, config.product, {
      price: Number(config.product.price).toFixed(2),
      compare_at_price: Number(config.product.compare_at_price).toFixed(2),
      list: ''
    });
    // Elevar owns event_id creation and forwards this event to GTM and the server.
    elevarLayer.push({
      event: 'dl_view_item',
      user_properties: Object.assign({ visitor_type: config.visitorType }, userData.user_properties || {}),
      ecommerce: {
        currencyCode: config.currency,
        detail: {
          actionField: { action: 'detail', list: '' },
          products: [product]
        }
      }
    });
  }

  check();
})();
